import {
  Briefcase,
  UserRound,
  Map,
  Building2,
  Home,
  DollarSign,
  FileText,
  Wallet,
  BarChart3,
  TrendingUp,
  TrendingDown,
} from "lucide-react";

/* Comparison ("Live Here, Work There") tour content, ported from the mobile
   "Comparison Detail" mockup. The generic GuidedTour engine renders these;
   this is just the data. Steps whose target hasn't rendered yet (e.g. the
   metrics before locations are picked) auto-skip. */
export default function getComparisonTourSteps() {
  return [
    {
      cardSelector: '[data-tour="cmp-inputcard"]',
      targetSelector: '[data-tour="cmp-work"]',
      icon: <Briefcase />,
      title: "Work Location",
      text: "Where your job is based. This sets the salary side of the comparison.",
    },
    {
      cardSelector: '[data-tour="cmp-inputcard"]',
      targetSelector: '[data-tour="cmp-role"]',
      icon: <UserRound />,
      title: "Nursing role",
      text: "Pick your position — pay data is pulled for this role.",
    },
    {
      cardSelector: '[data-tour="cmp-inputcard"]',
      targetSelector: '[data-tour="cmp-workstate"]',
      icon: <Map />,
      title: "Work State",
      text: "The state where you work, used for gross salary and taxes.",
    },
    {
      cardSelector: '[data-tour="cmp-inputcard"]',
      targetSelector: '[data-tour="cmp-workcity"]',
      icon: <Building2 />,
      title: "Work City",
      text: "The city where you work.",
    },
    {
      cardSelector: '[data-tour="cmp-inputcard"]',
      targetSelector: '[data-tour="cmp-live"]',
      icon: <Home />,
      title: "Living Location",
      text: "Where you actually live — this sets your cost of living.",
    },
    {
      cardSelector: '[data-tour="cmp-inputcard"]',
      targetSelector: '[data-tour="cmp-livestate"]',
      icon: <Map />,
      title: "Live State",
      text: "Living state affects your state income tax.",
    },
    {
      cardSelector: '[data-tour="cmp-inputcard"]',
      targetSelector: '[data-tour="cmp-livecity"]',
      icon: <Building2 />,
      title: "Live City",
      text: "Living city sets housing and everyday costs.",
    },
    {
      cardSelector: '[data-tour="cmp-salary"]',
      targetSelector: '[data-tour="cmp-salary"]',
      icon: <DollarSign />,
      title: "Median Gross Salary",
      text: "Typical monthly pay for this role in your work location.",
    },
    {
      cardSelector: '[data-tour="cmp-housing"]',
      targetSelector: '[data-tour="cmp-housing"]',
      icon: <Home />,
      title: "Average Housing Cost",
      text: "Estimated monthly rent where you live.",
    },
    {
      cardSelector: '[data-tour="cmp-taxes"]',
      targetSelector: '[data-tour="cmp-taxes"]',
      icon: <FileText />,
      title: "Income Taxes",
      text: "Combined state and federal tax taken each month.",
    },
    {
      cardSelector: '[data-tour="cmp-remaining"]',
      targetSelector: '[data-tour="cmp-remaining"]',
      icon: <Wallet />,
      title: "Remaining Income",
      text: "What's left each month after housing and taxes.",
    },
    {
      cardSelector: '[data-tour="cmp-ive"]',
      targetSelector: '[data-tour="cmp-ive"]',
      icon: <BarChart3 />,
      title: "Income vs Expenses",
      text: "How your income stacks up against total monthly expenses.",
    },
    {
      cardSelector: '[data-tour="cmp-ive"]',
      targetSelector: '[data-tour="cmp-legend-income"]',
      icon: <TrendingUp />,
      title: "Income",
      text: "Your total monthly income.",
    },
    {
      cardSelector: '[data-tour="cmp-ive"]',
      targetSelector: '[data-tour="cmp-legend-expenses"]',
      icon: <TrendingDown />,
      title: "Expenses",
      text: "Your total monthly expenses.",
    },
    {
      cardSelector: '[data-tour="cmp-ive"]',
      targetSelector: '[data-tour="cmp-balance"]',
      icon: <Wallet />,
      title: "Monthly balance",
      text: "Income minus expenses — your monthly surplus.",
    },
    {
      cardSelector: '[data-tour="cmp-ive"]',
      targetSelector: '[data-tour="cmp-income-bar"]',
      icon: <BarChart3 />,
      title: "Monthly Income",
      text: "Income shown to scale on the chart.",
    },
    {
      cardSelector: '[data-tour="cmp-ive"]',
      targetSelector: '[data-tour="cmp-expenses-bar"]',
      icon: <BarChart3 />,
      title: "Total Monthly Expenses",
      text: "Expenses shown to scale for easy comparison.",
    },
  ];
}
